export const volumes = [
  {
    numeral: 'I',
    title: 'The TRT Evaluation Blueprint',
    subtitle: 'Organize the Initial Assessment Before Considering Treatment',
    intro:
      'The foundation of responsible testosterone therapy begins with appropriate evaluation. In this volume, you’ll explore a structured approach to organizing the initial clinical assessment, including relevant symptoms, medical history, physical examination considerations, and the distinction between suspected testosterone deficiency and a properly supported diagnosis.',
    items: [
      'A structured overview of the initial patient evaluation.',
      'Relevant symptoms and clinical history considerations.',
      'Diagnostic confirmation and the role of repeat morning testosterone measurements.',
      'An educational overview of total testosterone and when additional assessment may be relevant.',
      'Differential diagnosis considerations.',
      'A checklist for organizing the initial evaluation.',
      'A reference map of questions to address before moving to the next stage.',
    ],
    objective: 'Help you organize the initial evaluation without overlooking important clinical considerations.',
    note: '',
  },
  {
    numeral: 'II',
    title: 'The Testosterone Lab Interpretation Guide',
    subtitle: 'Understand the Laboratory Picture in Its Clinical Context',
    intro:
      'Laboratory results are only one part of the clinical assessment. This volume organizes key laboratory concepts and explains how results should be interpreted alongside symptoms, medical history, and other relevant findings.',
    items: [
      'Total testosterone: clinical context and interpretation.',
      'When free testosterone assessment may be appropriate.',
      'SHBG and factors that can affect interpretation.',
      'LH and FSH in the evaluation of potential causes.',
      'Prolactin and other investigations when clinically indicated.',
      'Common pre-analytical and interpretive pitfalls.',
      'A laboratory review worksheet.',
      'A structured guide to questions raised by unexpected results.',
    ],
    objective:
      'Help you organize laboratory findings within a broader clinical evaluation instead of treating isolated numbers as a diagnosis.',
    note: '',
  },
  {
    numeral: 'III',
    title: 'The TRT Candidate Assessment Framework',
    subtitle: 'Structure the Review of Potential Candidates for Therapy',
    intro:
      'Not every patient with fatigue, low libido, or a single low testosterone result is an appropriate candidate for testosterone therapy. This volume focuses on organizing the considerations involved in determining whether further evaluation or treatment may be appropriate.',
    items: [
      'Diagnostic criteria and the importance of compatible symptoms.',
      'Confirmation of biochemical findings.',
      'Relevant medical history and comorbidities.',
      'Contraindications, precautions, and reasons to defer treatment.',
      'Fertility considerations and the potential effects of exogenous testosterone on spermatogenesis.',
      'Patient expectations and shared decision-making.',
      'Questions to review before discussing treatment options.',
      'A candidate-assessment checklist.',
    ],
    objective: 'Support a more structured, individualized assessment before treatment decisions are made.',
    note: '',
  },
  {
    numeral: 'IV',
    title: 'The TRT Treatment Planning Blueprint',
    subtitle: 'Organize Treatment Considerations Around the Individual Patient',
    intro:
      'Once treatment is being considered, the next challenge is organizing the relevant options, safety considerations, and patient-specific factors. This volume provides an educational framework for reviewing treatment approaches and planning appropriate clinical discussions.',
    items: [
      'An overview of commonly used testosterone formulations.',
      'Considerations when comparing delivery methods.',
      'Route-specific administration and safety considerations.',
      'Factors that influence treatment selection.',
      'Patient counseling and informed consent.',
      'Baseline assessment and documentation considerations.',
      'An overview of formulation-specific monitoring.',
      'A treatment-planning worksheet.',
    ],
    objective:
      'Help you organize the factors that inform individualized treatment planning rather than relying on a one-size-fits-all approach.',
    note: 'Treatment choices and dosing must be based on current evidence, applicable guidelines, product-specific prescribing information, and individual clinical assessment.',
  },
  {
    numeral: 'V',
    title: 'The TRT Safety & Monitoring System',
    subtitle: 'Keep Safety Considerations Visible Throughout Ongoing Care',
    intro:
      'Starting therapy is not the end of the clinical process. Appropriate follow-up and monitoring remain essential. This volume organizes important considerations for ongoing assessment and the identification of findings that may require further evaluation or intervention.',
    items: [
      'A structured overview of follow-up considerations.',
      'Testosterone monitoring and interpretation in the context of treatment.',
      'Hematocrit monitoring and erythrocytosis considerations.',
      'Prostate-related assessment and monitoring considerations, where appropriate.',
      'Review of symptoms, response, and potential adverse effects.',
      'Fertility counseling and relevant long-term considerations.',
      'Situations that may require reassessment, treatment modification, or specialist input.',
      'A monitoring checklist and follow-up documentation template.',
    ],
    objective: 'Provide an organized reference for reviewing safety and monitoring considerations throughout treatment.',
    note: '',
  },
  {
    numeral: 'VI',
    title: 'The TRT Clinical Workflow Playbook',
    subtitle: 'Bring the Pieces Together Into a Repeatable Clinical Reference',
    intro:
      'The final volume connects the previous five into a practical framework you can consult throughout the patient journey. Rather than presenting isolated information, it helps you organize the stages of evaluation, decision-making, treatment planning, and follow-up.',
    items: [
      'A visual overview of the TRT clinical workflow.',
      'A step-by-step map of the major evaluation stages.',
      'A checklist for reviewing clinical information before decisions are made.',
      'A structured patient consultation outline.',
      'Documentation and follow-up planning templates.',
      'A guide to common workflow gaps.',
      'A framework for identifying when additional investigation or specialist referral may be appropriate.',
      'A quick-reference index linking the six volumes.',
    ],
    objective:
      'Make your TRT reference materials easier to navigate, review, and incorporate into your professional workflow.',
    note: '',
  },
];
